import { createSlice } from "@reduxjs/toolkit";

import { v4 as uuidv4 } from "uuid";

const initialState = {
  initialData: {
    settingsNetwork: {
      data: {
        deviceNetwork: {
          mgmtVlan: 1,
          version: 1,
          ipv4: {
            gateway: null,
            ipAddress: null,
            primaryDns: null,
            secondaryDns: null,
            subnetMask: null,
            type: "dhcp",
          },
          ipv6: {
            gateway: null,
            ipAddress: null,
            prefixLength: null,
            primaryDns: null,
            secondaryDns: null,
            type: "disable",
          },
        },
        info: {
          address: null,
          deviceName: "DMS-3130-30PS 07:31",
          latitude: null,
          longitude: null,
        },
        "wireless.radio": [
          {
            "config": {
              "band": "2",
              "chanWidth": "Auto",
              "channel": "Auto",
              "dfsChannels": true,
              "h2040Coexistence": false,
              "id": "e009d6b2-2397-480d-863d-219f0b8f4852",
              "pscChannels": false,
              "rssiThreshold": 1,
              "rssiThresholdEnable": false,
              "txPower": 100,
              "version": 2,
              "wirelessMode": "Auto"
            },
            "override": false
          },
          {
            "config": {
              "band": "5",
              "chanWidth": "Auto",
              "channel": "Auto",
              "dfsChannels": true,
              "h2040Coexistence": null,
              "id": "e04d2a18-3cb9-4b7c-8071-39694448f70b",
              "pscChannels": null,
              "rssiThreshold": null,
              "rssiThresholdEnable": false,
              "txPower": 100,
              "version": 1,
              "wirelessMode": "Auto"
            },
            "override": false
          },
          {
            "config": {
              "band": "6",
              "chanWidth": "Auto",
              "channel": "Auto",
              "dfsChannels": null,
              "h2040Coexistence": null,
              "id": "f1f3f5e2-5d4b-4c2a- ninth-8e2b7f4c3d6a",
              "pscChannels": null,
              "rssiThreshold": null,
              "rssiThresholdEnable": false,
              "txPower": 100,
              "version": 1,
              "wirelessMode": "Auto"
            },
            "override": false
          }
        ],
        "deviceTag": [
          "ac11ce0-75cd-4bdc-ba47-13223b2c8a75",
          "a1793265-bf9f-49a2-a46a-8d281d075af8",
          "tag-uuid-abcdef01-2345-6789-abcd-ef0123456789"
        ]
      },
    },
    statistic: {
      data: {
        cpuStats: [
          { timestamp: 1762395900, usagePercent: null },
          { timestamp: 1762419600, usagePercent: 4 },
          { timestamp: 1762425300, usagePercent: 3.6666667461395264 }
        ],
        memStats: [
          { timestamp: 1762395900, usagePercent: null },
          { timestamp: 1762419600, usagePercent: 68.9 },
          { timestamp: 1762425300, usagePercent: 70.2 }
        ],
        trafficStats: {
          txStats: [
            { timestamp: 1729392000, "usage": 158.3 },
            { timestamp: 1729392600, "usage": 162.1 }
          ],
          rxStats: [
            { timestamp: 1729392000, "usage": 240.5 },
            { timestamp: 1729392600, "usage": 255.7 }
          ]
        },
        wanTrafficStats: [
          {
            "interfaceName": "WAN1",
            "trafficStats": {
              "txStats": [
                { timestamp: 1762395900, usagePercent: null },
                { timestamp: 1762419600, usagePercent: 4 },
                { timestamp: 1762425300, usagePercent: 3.6666667461395264 }
              ],
              "rxStats": [
                { timestamp: 1762395900, usagePercent: null },
                { timestamp: 1762419600, usagePercent: 68.9 },
                { timestamp: 1762425300, usagePercent: 70.2 }
              ]
            }
          },
          {
            "interfaceName": "WAN2",
            "trafficStats": {
              "txStats": [
                { timestamp: 1762395900, usagePercent: null },
                { timestamp: 1762419600, usagePercent: 4 },
                { timestamp: 1762425300, usagePercent: 99 }
              ],
              "rxStats": [
                { timestamp: 1762395900, usagePercent: null },
                { timestamp: 1762419600, usagePercent: 33.9 },
                { timestamp: 1762425300, usagePercent: 77 }
              ]
            }
          },
          {
            "interfaceName": "WAN3",
            "trafficStats": {
              "txStats": [
                { timestamp: 1762395900, usagePercent: null },
                { timestamp: 1762419600, usagePercent: 4 },
                { timestamp: 1762425300, usagePercent: 39 }
              ],
              "rxStats": [
                { timestamp: 1762395900, usagePercent: null },
                { timestamp: 1762419600, usagePercent: 50.2 },
                { timestamp: 1762425300, usagePercent: 11 }
              ]
            }
          }
        ]
      }
    },
    tunnelAccess: {
      "status": "success",
      "endpoint": "https://heron-1.dlink.com/<rac|raw>?s=6c287360-c42a-45fe-bce6-23286a55a4b4"
    }
  },
  selecterDevicesData: {
    data: [],
  },
  selecterDevicesDrawerData: {
    data: {},
  },
  deviceTag: {
    "data": [
      {
        "tagId": "ac11ce0-75cd-4bdc-ba47-13223b2c8a39",
        "tagName": "Root Node"
      },
      {
        "tagId": "ac11ce0-75cd-4bdc-ba47-13223b2c8a75",
        "tagName": "Bad"
      },
      {
        "tagId": "5ac11ce0-75cd-4bdc-ba47-13223b2c8a75",
        "tagName": "3F-A1"
      },
      {
        "tagId": "a1793265-bf9f-49a2-a46a-8d281d075af8",
        "tagName": "Taipei"
      },
      {
        "tagId": "tag-uuid-abcdef01-2345-6789-abcd-ef0123456789",
        "tagName": "Conference Room"
      }
    ]
  },
  updateEditDeviceTag: {},
  updateDeleteDeviceTag: {
    "message": "Device tags deleted successfully",
    "resource": "/orgs/ca376817-5bfc-4f0a-98cf-9a01e5aa3c1b/sites/f3b04305-42ce-4cac-b954-03893360eeee/settings/tags/deviceTags"
  },
};

export const devicesDrawerContentSlice = createSlice({
  name: "devicesDrawerContent",
  initialState,
  reducers: {
    setDrawerDevicesData: (state, action) => {
      if (Object.prototype.hasOwnProperty.call(action.payload.data, "info")) {
        state.initialData.settingsNetwork.data = action.payload.data;
      }
      if (Object.prototype.hasOwnProperty.call(action.payload.data, "deviceTag")) {
        state.initialData.deviceTag = action.payload.data;
      }
    },
    setDeviceTagData: (state, _action) => {
      state.deviceTag.data = { tagId: uuidv4() }
    },
    setEditDeviceTagData: (state, action) => {
      const updatedItem = action.payload;

      const target = state.deviceTag.data.find(
        item => item.tagId === updatedItem.tagId
      );

      if (target) {
        Object.assign(target, updatedItem);
      }

      state.updateEditDeviceTag = updatedItem
    },
    setDeleteDeviceTagData: (state, action) => {
      const { tagId } = action.payload;
      state.deviceTag.data = state.deviceTag.data.filter(item => item.tagId !== tagId);
    },
  },
});

export const { setDrawerDevicesData, setDeviceTagData, setEditDeviceTagData, setDeleteDeviceTagData } = devicesDrawerContentSlice.actions;
export default devicesDrawerContentSlice.reducer;
